import { trackingPageOrderSchema } from "@redotech/redo-model/order-tracking/tracking-page-order-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTrackingPageOrder = {
  name: "getTrackingPageOrder" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({ trackingPageOrder: trackingPageOrderSchema.nullable() }),
};
